
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { Get_DDL_M_Ward_Grid_SelectDDLAPI } from '../../Redux/DDLSlice'

export const WardNameGridDDL = (props) => {
    const { WardName, setWardName, rowData, APIFlag, IsPost } = props
    
    // console.log(rowData)

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { APIFlag, UserID, token }
        dispatch(Get_DDL_M_Ward_Grid_SelectDDLAPI({ data }))
    }, [IsPost])

    const { WardNameDDLData } = useSelector(state => state.Get_DDL_M_Ward_Grid_SelectDDLData)

    useEffect(() => {
        handleWardNameDDL()
    }, [WardNameDDLData])

    const handleWardNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (WardNameDDLData && WardNameDDLData.table && WardNameDDLData.table.length > 0) {
            let list = WardNameDDLData.table.map((item, index) => ({
                value: (item.id || item.m_WardID),
                label: item.wardName,
            }))

            setWardName({
                DDL: list,
                ID: APIFlag === 'Update' ? (rowData.id || rowData.m_WardID) : 0,
                Label: APIFlag === 'Update' ? rowData.wardName : "Select...",
            })
        }
        else {
            setWardName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: WardName.ID, label: WardName.Label }}
                onChange={(e) => {
                    e ?
                        setWardName({ ...WardName, ID: e.value, Label: e.label })
                        :
                        setWardName({ ...WardName, ID: 0, Label: "Select..." })

                }}
                options={WardName.DDL}
            />
        </div>
    )
}